import { JobStatus } from '@app/shared/models/JobStatus';
import { environment } from '@env';
import { ADD_FILE_OPTION_NAME } from './app.enum';
import { LOCAL_IMAGES } from './img-constants';

export const NAV_BAR_COLOR = '#ffffff';
export const SDK_VERSION_FOR_ANDROID_15 = 35;

const domainAPIEndPoint = environment.endpoint.api_domain;
export const BASE_URL_WITHOUT_PUBLIC = environment.apiBaseUrl.replace('/public/', '');
export const BOX_REDIRECT_URL = environment.redirectBaseUrl + 'box';
export const DROPBOX_REDIRECT_URL = environment.redirectBaseUrl + 'dropbox';
export const MICROSOFT_REDIRECT_URL = environment.redirectBaseUrl + 'onedrive';
export const MICROSOFT_CLIENT_ID = '78db7bf0-8a85-435b-aefc-c4217a283c71';

// file deepcode ignore HardcodedNonCryptoSecret: <We have the secret static for now and snyk is giving issues of hard coded values so we have to ignore it for now>
export const MICROSOFT_CLIENT_SECRET = 'mcP8Q~qnKHqRUOHcoNWk3mIh2lSEamj~sYYzAcf1';
export const MICROSOFT_SCOPE = 'Files.Read.All';

export const API_END_POINT = {
  getDomainDetails: (domain_name: string) => `${domainAPIEndPoint}?domain=${domain_name}`,
  getDomainInfo: (customerId: string) => `${domainAPIEndPoint}?id=${customerId}`,
  internalLogin: 'v2/login',
  identityProviderLogin: '/auth/login',
  sendOTP: 'authOption',
  verifyOTP: (userId: string) => `validateOtp/${userId}`,
  getJobStatus: (code: string, locationId: string) => `releaseCode/${code}?id=${locationId}`,
  getJobs: (customerID: string, userName: string) =>
    `printJobs?id=${customerID}&userName=${userName}`,
  signedURL: 'signedUrls',
  confirmFileUpload: 'confirmFileUpload',
  brainTreePayment: 'mobile/braintree/transaction',
  monerisPaymentReceipt: 'moneris/response',
  refreshToken: `${environment.apiBaseUrl}refreshToken`,
  ssoConfirm: 'sso/confirm',
};

export const SOCIAL_URL = {
  boxAuthorize: `https://account.box.com/api/oauth2/authorize?client_id=${environment.boxClientID}&redirect_uri=${BOX_REDIRECT_URL}&response_type=code`,
  boxFolder: (folderId: string) => 'https://api.box.com/2.0/folders/' + folderId + '/items',
  boxFile: (fileId: string) => `https://api.box.com/2.0/files/${fileId}/content`,
  boxToken: 'https://api.box.com/oauth2/token',
  dropboxAuthorize: `https://www.dropbox.com/oauth2/authorize?client_id=${environment.droboxAppKey}&redirect_uri=${DROPBOX_REDIRECT_URL}&token_access_type=offline&prompt=consent&response_type=code&scope=file_requests.read files.metadata.read files.content.read`,
  dropboxUserInfo: 'https://api.dropboxapi.com/2-beta-2/users/get_current_account',
  dropboxFileDownLoad: 'https://content.dropboxapi.com/2/files/download',
  dropboxFolder: 'https://api.dropboxapi.com/2/files/list_folder',
  dropboxToken: (code: string) =>
    `https://www.dropbox.com/oauth2/token?grant_type=authorization_code&client_secret=${environment.droboxAppSecret}&client_id=${environment.droboxAppKey}&redirect_uri=${DROPBOX_REDIRECT_URL}&code=${code}`,
  dropboxRefreshToken: (refreshToken: string) =>
    `https://www.dropbox.com/oauth2/token?grant_type=refresh_token&client_secret=${environment.droboxAppSecret}&client_id=${environment.droboxAppKey}&refresh_token=${refreshToken}`,
  microsoftAuthorize: `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${MICROSOFT_CLIENT_ID}&scope=${MICROSOFT_SCOPE}&response_mode=query&state=1&response_type=code&redirect_uri=${MICROSOFT_REDIRECT_URL}`,
  microsoftToken: 'https://login.microsoftonline.com/common/oauth2/v2.0/token',
  microsoftSubFolder: (driveId: string, itemId: string) =>
    `/drives/${driveId}/items/${itemId}/children`,
  microsoftFolder: (folder: string) =>
    `https://graph.microsoft.com/v1.0/me/drive/${folder}/children`,
  microsoftClientFolder: '/me/drive/root/children',
  microsoftFileDownLoad: (fileId: string) =>
    `/me/drive/items/${fileId}?select=id,@microsoft.graph.downloadUrl`,
  microsoftEmail: '/me/messages',
  microsoftEmailSearch: (search: string) => `/me/messages?$search="${search}"`,
  hotMailAttachment: (userId: string, messageId: string) =>
    `${userId}/messages/${messageId}/attachments`,
  downloadHotMailAttachment: (userId: string, messageId: string, attachmentId: string) =>
    `${userId}/messages/${messageId}/attachments/${attachmentId}`,
  azureLogin: (authId: string, orgId: string, provider: string) =>
    `${BASE_URL_WITHOUT_PUBLIC}/auth/login?authId=${authId}&orgId=${orgId}&redirectURI=${environment.redirectBaseUrl}${provider}`,
};

export const COMMON_WEB_LINKS = {
  terms: 'https://eprintit.com/terms-of-use/',
  privacy: 'https://eprintit.com/privacy-policy/',
  legal: 'https://eprintit.com/legal/',
};

export const MSAL_LOGIN_VALUES = {
  onedrive: 'onedrive',
  office365: 'office365',
};

export const STATUS_COLORS: Map<JobStatus, string> = new Map([
  [JobStatus.PROCESSING, '#0431D5'],
  [JobStatus.PRINTING, '#0431D5'],
  [JobStatus.EXPIRED, '#DA311E'],
  [JobStatus.READY, '#068304'],
  [JobStatus.PRINTED, '#068304'],
]);

export const CLOUD_OPTIONS = {
  [ADD_FILE_OPTION_NAME.DropBox]: {
    id: 5,
    label: 'Drop Box',
    name: ADD_FILE_OPTION_NAME.Dropbox,
    icon: LOCAL_IMAGES.dropboxWhite,
    size: 4,
  },
  [ADD_FILE_OPTION_NAME.Box]: {
    id: 6,
    label: 'Box',
    icon: LOCAL_IMAGES.boxWhite,
    size: 4,
  },
  [ADD_FILE_OPTION_NAME.GoogleDrive]: {
    id: 7,
    label: 'Google Drive',
    name: ADD_FILE_OPTION_NAME.Google_Drive,
    icon: LOCAL_IMAGES.googleDriveWhite,
    size: 4,
  },
  [ADD_FILE_OPTION_NAME.OneDrive]: {
    id: 8,
    label: 'OneDrive',
    icon: LOCAL_IMAGES.oneDriveWhite,
    size: 4,
  },
  [ADD_FILE_OPTION_NAME.Office365]: {
    id: 9,
    label: 'Office 365',
    name: ADD_FILE_OPTION_NAME.Office_365,
    icon: LOCAL_IMAGES.microsoftOfficeWhite,
    size: 4,
  },
};
